import React from "react";

interface CustomizeIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const CustomizeIcon: React.FC<CustomizeIconProps> = ({
  width = 16,
  height = 18,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      preserveAspectRatio="none"
      width={width}
      height={height}
      overflow="visible"
      style={{ display: "block" }}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        id="Vector"
        d="M8 0L16 4.5V13.5L8 18L0 13.5V4.5L8 0ZM8 11.4545C8.67002 11.4545 9.3126 11.1959 9.78638 10.7356C10.2602 10.2753 10.5263 9.65099 10.5263 9C10.5263 8.34901 10.2602 7.72469 9.78638 7.26437C9.3126 6.80406 8.67002 6.54545 8 6.54545C7.32998 6.54545 6.6874 6.80406 6.21362 7.26437C5.73985 7.72469 5.47368 8.34901 5.47368 9C5.47368 9.65099 5.73985 10.2753 6.21362 10.7356C6.6874 11.1959 7.32998 11.4545 8 11.4545Z"
        fill={fill}
      />
    </svg>
  );
};

export default CustomizeIcon;
